// Tiny event bus so the global <StepUpModal /> can be triggered from anywhere
// (specifically the axios 428 interceptor). No React state — just callbacks.
//
// Usage:
//   const ok = await requestStepUp();  // opens the modal, resolves true/false
//   registerHandler(fn)                // called once by <StepUpModal />
//
let handler = null;

export function registerHandler(fn) {
    handler = fn;
    return () => {
        if (handler === fn) handler = null;
    };
}

export function requestStepUp() {
    if (!handler) return Promise.resolve(false);
    return handler();
}
